module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point5/popup/bg.png')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Я не была в Румынии, но увидеть своими глазами величие Карпатских гор и ощутить силу природы - моя мечта.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Карпатские горы, Румыния\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Карпатские горы\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    Румынские Карпаты, где Weleda выращивает арнику для своего знаменитого массажного масла, — это регион богатой культуры, в том числе фермерской: большинство местных жителей, занятых в проекте Weleda (более 480 человек ), происходят из семей, в которых навыки собирательства и культивирования передаются по наследству. Урожай арники собирают летом — по особой методике, разработанной вместе со Всемирным фондом дикой природы: с каждого растения снимают ограниченное количество желтых цветков, чтобы популяция дикорастущей арники сохранялась и росла. За восемь лет площадь земель с цветущей арникой серьезно увеличилась — Карпаты становятся по-настоящему «золотыми».\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Массажное масло "), _c('br'), _vm._v(" с арникой\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        100% натуральное масло с арникой, созданное в 1923 году, пользуется доверием среди профессиональных спортсменов и физиотерапевтов. Оно отлично подходит ценителям активного образа жизни.\n                    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/c%D1%8B%D1%80%D1%8C%D0%B5%D0%B2%D1%8B%D0%B5-%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D1%8B/%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%B0?utm_source=afisha&utm_medium=card&utm_content=arnica&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point5/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e42f39c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/popups/popup5.vue
// module id = 548
// module chunks = 1